var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.181 8.15404L10.056 1.8207C9.73935 1.5832 9.34352 1.5832 9.02685 1.8207L1.90185 8.15404C1.58518 8.4707 1.50602 8.9457 1.82268 9.26237C2.13935 9.57904 2.61435 9.6582 2.93102 9.34154L3.16852 9.02487V16.6249C3.16852 17.0999 3.48518 17.4165 3.96018 17.4165H15.0435C15.5185 17.4165 15.8352 17.0999 15.8352 16.6249V9.02487L16.0727 9.26237C16.3893 9.57904 16.8644 9.49987 17.181 9.1832C17.4977 8.9457 17.4977 8.39154 17.181 8.15404ZM11.0852 11.8749H10.2935V12.6665C10.2935 13.1415 9.97685 13.4582 9.50185 13.4582C9.02685 13.4582 8.71018 13.1415 8.71018 12.6665V11.8749H7.91852C7.44352 11.8749 7.12685 11.5582 7.12685 11.0832C7.12685 10.6082 7.44352 10.2915 7.91852 10.2915H8.71018V9.49987C8.71018 9.02487 9.02685 8.7082 9.50185 8.7082C9.97685 8.7082 10.2935 9.02487 10.2935 9.49987V10.2915H11.0852C11.5602 10.2915 11.8769 10.6082 11.8769 11.0832C11.8769 11.5582 11.5602 11.8749 11.0852 11.8749Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpoke);
export default __webpack_public_path__ + "static/media/Spoke.549ba5015b4783bf58ce1fc8d3fbcb8d.svg";
export { ForwardRef as ReactComponent };